/* istanbul ignore file */
import React from "react";
import { createRoot } from "react-dom/client";

import { initializeFeatureFlags } from "@utils/featureFlags";

import { configureAmplify } from "./amplify";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "react-toastify/dist/ReactToastify.css";

import "./index.css";

const APP_NAME = "ct-maple";

configureAmplify();

initializeFeatureFlags(APP_NAME);

const container = document.getElementById("app");
const root = createRoot(container);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
